/**
 * <feyza-hero> — Feyza Kids hero slider
 *
 * Bağımlılık yok. Otomatik geçiş; sekme arka plandayken, imleç üzerindeyken,
 * odak içerideyken, bölüm ekranda değilken ve prefers-reduced-motion açıkken durur.
 */
class FeyzaHero extends HTMLElement {
  connectedCallback() {
    this.slides = Array.from(this.querySelectorAll('[data-fh-slide]'));
    if (this.slides.length === 0) return;

    this.dots = Array.from(this.querySelectorAll('[data-fh-dot]'));
    this.liveRegion = this.querySelector('[data-fh-live]');
    this.pauseBtn = this.querySelector('[data-fh-pause]');

    this.index = this.slides.findIndex(function (s) { return s.dataset.active === 'true'; });
    if (this.index < 0) this.index = 0;

    this.interval = Math.max(2000, parseInt(this.dataset.interval || '6000', 10));
    this.autoplayAllowed =
      this.dataset.autoplay === 'true' &&
      this.slides.length > 1 &&
      !window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    this.paused = false;
    this.inView = true;
    this.timer = null;

    this.bind();
    this.render();

    if (this.autoplayAllowed) this.observe();
    else if (this.pauseBtn) this.pauseBtn.hidden = true;
  }

  disconnectedCallback() {
    this.stop();
    if (this.observer) this.observer.disconnect();
  }

  bind() {
    const self = this;
    const prev = this.querySelector('[data-fh-prev]');
    const next = this.querySelector('[data-fh-next]');
    if (prev) prev.addEventListener('click', function () { self.go(self.index - 1, true); });
    if (next) next.addEventListener('click', function () { self.go(self.index + 1, true); });

    this.dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () { self.go(i, true); });
    });

    if (this.pauseBtn) {
      this.pauseBtn.addEventListener('click', function () {
        self.paused = !self.paused;
        self.pauseBtn.setAttribute('aria-pressed', String(self.paused));
        self.pauseBtn.dataset.state = self.paused ? 'paused' : 'playing';
        self.pauseBtn.setAttribute('aria-label', self.paused ? 'Otomatik geçişi başlat' : 'Otomatik geçişi duraklat');
        if (self.paused) self.stop(); else self.start();
      });
    }

    this.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); self.go(self.index - 1, true); }
      if (e.key === 'ArrowRight') { e.preventDefault(); self.go(self.index + 1, true); }
    });

    this.addEventListener('pointerenter', function () { self.stop(); });
    this.addEventListener('pointerleave', function () { self.start(); });
    this.addEventListener('focusin', function () { self.stop(); });
    this.addEventListener('focusout', function (e) {
      if (!self.contains(e.relatedTarget)) self.start();
    });

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) self.stop(); else self.start();
    });

    let startX = null;
    let startY = null;
    this.addEventListener('touchstart', function (e) {
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
    }, { passive: true });

    this.addEventListener('touchend', function (e) {
      if (startX === null) return;
      const dx = e.changedTouches[0].clientX - startX;
      const dy = e.changedTouches[0].clientY - startY;
      if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) {
        self.go(self.index + (dx < 0 ? 1 : -1), true);
      }
      startX = null;
      startY = null;
    }, { passive: true });
  }

  observe() {
    const self = this;
    if (typeof IntersectionObserver === 'undefined') { this.start(); return; }
    this.observer = new IntersectionObserver(function (entries) {
      self.inView = entries[0].isIntersecting;
      if (self.inView) self.start(); else self.stop();
    }, { threshold: 0.25 });
    this.observer.observe(this);
  }

  go(next, userInitiated) {
    const total = this.slides.length;
    this.index = ((next % total) + total) % total;
    this.render();
    if (userInitiated) { this.stop(); this.start(); }
  }

  render() {
    const active = this.index;
    this.slides.forEach(function (slide, i) {
      const isActive = i === active;
      slide.dataset.active = String(isActive);
      slide.setAttribute('aria-hidden', String(!isActive));
      slide.querySelectorAll('a, button').forEach(function (el) {
        if (isActive) el.removeAttribute('tabindex');
        else el.setAttribute('tabindex', '-1');
      });
    });
    this.dots.forEach(function (dot, i) {
      dot.setAttribute('aria-current', String(i === active));
    });
    if (this.liveRegion) {
      this.liveRegion.textContent = (this.index + 1) + ' / ' + this.slides.length;
    }
  }

  start() {
    if (!this.autoplayAllowed || this.paused || !this.inView || document.hidden) return;
    this.stop();
    const self = this;
    this.timer = window.setInterval(function () { self.go(self.index + 1, false); }, this.interval);
  }

  stop() {
    if (this.timer) { window.clearInterval(this.timer); this.timer = null; }
  }
}

if (!customElements.get('feyza-hero')) customElements.define('feyza-hero', FeyzaHero);
